import type { DonationBusinessesApiDto } from '__generated__/api/unauth/types.gen';

import { SearchEmptyResults } from '../SearchEmptyResults';
import { SearchDonationCard } from './SearchDonationCard';

export function DonationBusinessList({
  items,
}: {
  items: DonationBusinessesApiDto[];
}) {
  if (items.length < 1) return <SearchEmptyResults />;

  return (
    <ul className="flex flex-col gap-20 pb-40 mobile-tablet:gap-16 mobile-tablet:px-20">
      {items.map((item) => (
        <li key={item.donationBusinessId}>
          <SearchDonationCard
            businessId={item.donationBusinessId ?? 0}
            thumbnailUrl={item.thumbnailUrl ?? ''}
            title={item.donationBusinessName ?? ''}
            institutionName={item.institutionName ?? ''}
            endDate={item.endDate}
            donationAmount={Math.max(
              (item.goalAmt ?? 0) - (item.rmAmt ?? 0),
              0,
            )}
            achievementRate={item.achievementRate ?? 0}
            isEnded={item.specificDonationStatus === 'ENDED'}
          />
        </li>
      ))}
    </ul>
  );
}
